import React from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import PersonBox from '../Shoppinglist/PersonBox';
import EmptyShoppingList from '../General/EmptyShoppingList';

const ShoppingList = (props) => {
    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [shoppinglist] = useGlobal(
        state => state.shoppinglist
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    let shoppinglistPeople = [];
    shoppinglist.forEach((sl) => {
        var i = shoppinglistPeople.findIndex(x => x.userID === sl.userID);
        if(i <= -1){
            shoppinglistPeople.push({
                FBID: sl.FBID,
                FirstName: sl.FirstName,
                LastName: sl.LastName,
                avatarFile: sl.avatarFile,
                urlCode: sl.urlCode,
                userID: sl.userID
            });
        }
    });

    shoppinglistPeople = shoppinglistPeople.map(slp => {
        return {
            ...slp,
            items: shoppinglist.filter(sl => sl.userID = slp.userID)
        }
    });
    const shoppinglistBoxes = shoppinglistPeople.map(sp => <PersonBox key={sp.userID} {...sp}></PersonBox>);

    return (
        <Panel open={props.open && panel.name === "shoppinglist"}>
            {props.name === "shoppinglist" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white" kt-hidden-height="77">
                    <h3>Shopping List</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__body">
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >
                            {shoppinglistBoxes.length > 0 ? <></> : <EmptyShoppingList></EmptyShoppingList>}
                            {shoppinglistBoxes}
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default ShoppingList;